import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faEllipsis,
  faCloudDownload,
  faCheckCircle,
  faExclamationCircle,
  faTimes,
  faEye,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  orderHistory,
  cancelOrderPromocode,
} from "../../../controllers/V1/promocodes/promocodeController";
import { getPage } from "../../../controllers/common";
import ExportPopup from "./exportOrder";
import DownloadOrderStubsPopup from "./downloadOrderStubsPopup";
import { formatProjectDate } from "../../../controllers/common";
import { usePermissions } from "../../../controllers/PermissionContext";
import ConfirmPopup from "../../../components/ConfirmPopup";
import Loading from "../../../components/Loading/LoadingEffect";
import { list as generalData } from "../../../controllers/V1/cms/generalDataController";
import { statusMessage } from "../../../controllers/common";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("promoCodesOrder");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isStubDownloadShow, setStubDownloadShow] = useState(false);
  const handleStubDownloadDrawer = () => setStubDownloadShow(!isStubDownloadShow);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const toggleConfirmPopup = () => setConfirmPopup(!confirmPopup);

  const [cancelID, setCancelID] = useState("");

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "order_no",
    search: "ORBTP",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [fromDate, setFromDate] = useState(`${moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...((filter?.filter_by === "order_no" && filter?.search !== 'ORBTP')
            ? { order_no: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "buyer_first_name"
            ? { buyer_first_name: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "buyer_last_name"
            ? { buyer_last_name: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "buyer_mobile"
            ? { buyer_mobile: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "buyer_area"
            ? { buyer_area: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "seller_pos_number"
            ? { seller_pos_number: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "seller_first_name"
            ? { seller_first_name: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "seller_last_name"
            ? { seller_last_name: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "seller_mobile"
            ? { seller_mobile: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "code"
            ? { code: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "points"
            ? { points: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "qty"
            ? { qty: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "total_point"
            ? { total_point: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "status"
            ? { status: filter?.search }
            : null),
          ...(filter?.from
            ? { createdAt: { $gte: filter.from, $lte: filter.to } }
            : null),
          ...(showRequest ? { status: showRequest } : null),
        },

        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await orderHistory(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter("");
      setFromDate("");
      setToDate("");
      inputRef1.current.value = "";
      inputRef2.current.value = "";
      inputRef3.current.value = "";
      inputRef4.current.value = "";
    } catch (error) {}
  };

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const to = moment(form.get("to_date")).format("YYYY-MM-DD HH:mm:ss");
      const from = moment(form.get("from_date")).format("YYYY-MM-DD HH:mm:ss");
      setFilter((pre) => ({
        ...pre,
        // 'filter_by' : form.get('filter_by') || '',
        // 'search'    : form.get('search') || '',
        to: form.get("to_date") ? moment(to).format("YYYY-MM-DD HH:mm:ss") : "",
        from: form.get("from_date")
          ? moment(from).format("YYYY-MM-DD HH:mm:ss")
          : "",
      }));
      // getList();
      handleFiterDrawer();
      setSkip(0);
      setLimit(10);
    } catch (error) {}
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "filter_by" && value === "order_no") {
      setFilter((pre) => ({
        ...pre,
        [name]: value,
        search: "ORBTP",
      }));
    } else if (name === "filter_by" && value !== "order_no") {
      setFilter((pre) => ({
        ...pre,
        [name]: value,
        search: "",
      }));
    } else if(name === 'from_date'){
      setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else if(name === 'to_date'){
      setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else {
      setFilter((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
  };
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "Orbit Kuwait || Promo Code Order's list";
  }, [currentPage, showRequest, LIMIT, SKIP, isFilterShow]);

  const handleCancelOrder = async (id = "") => {
    try {
      setIsLoading(true);
      if (!cancelID) {
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      } else {
        const option = { order_id: cancelID };
        const res = await cancelOrderPromocode(option);
        if (res.status === true) {
          getList();
          notification.open({
            message: "Success",
            description: `Order Cancel successfully.`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faCheckCircle}
                style={{ color: "green" }}
              />
            ),
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ color: "red" }}
              />
            ),
            duration: 2,
          });
        }
      }
      setCancelID("");
      setIsLoading(false);
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while procession`,
        placement: "topRight",
        icon: (
          <FontAwesomeIcon
            icon={faExclamationCircle}
            style={{ color: "red" }}
          />
        ),
        duration: 2,
      });
      setCancelID("");
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
      try {
        const res = await generalData();
        if(res?.status === true){
          const { draw_start_time, draw_end_time } = res.result;
          if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
          if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
        }  
      } catch (error) {
        
      }
    }
    useEffect(()=>{
      getGeneralData();
    },[]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Promo Code's Order"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                    <Tab
                      label="Cancelled"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("Cancel");
                        setTotalPages(1);
                        setLimit(10);
                        setSkip(0);
                      }}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT} />
                  </div>
                  <div
                    className="inventory_filter_div"
                    onClick={handleFiterDrawer}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === "Y" ||
                    PERMISSION?.export === "Y") && (
                    <>
                      <div
                        className="inventory_filter_div"
                        onClick={handleExportDrawer}
                      >
                        <FontAwesomeIcon icon={faCloudDownload} />
                        <Link
                          to={false}
                          className="filter_btn_invontry_rating_review"
                        >
                          Export
                        </Link>
                      </div>
                      <div
                        className="inventory_filter_div"
                        onClick={handleStubDownloadDrawer}
                      >
                        <FontAwesomeIcon icon={faCloudDownload} />
                        <Link
                          to={false}
                          className="filter_btn_invontry_rating_review"
                        >
                          Stub PDF
                        </Link>
                      </div>
                    </>
                  )}
                  <div className="inventory_filter_div">
                    <Link to={false} onClick={() => getList()}>
                      <FontAwesomeIcon icon={faRefresh} />
                    </Link>
                  </div>
                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Order No</th>
                              <th>Buyer Details</th>
                              <th>Seller Details</th>
                              <th>Code</th>
                              <th>Points</th>
                              <th>Qty</th>
                              <th>Total Points</th>
                              <th>Expire Date</th>
                              <th>Status</th>
                              <th>Created Date & Time</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.order_no}</td>
                                    <td>
                                      Name :{" "}
                                      {`${items?.buyer_first_name} ${items?.buyer_last_name}`}{" "}
                                      <br />
                                      Ph. : {items.buyer_mobile} <br />
                                      {items?.buyer_area &&
                                        `Area : ${items.buyer_area}`} <br />
                                      {items?.cpr_number &&
                                        `CPR No. : ${items.cpr_number}`}
                                    </td>
                                    <td>
                                      Name : {items?.seller_first_name}{" "}
                                      {items?.seller_last_name} <br />
                                      Ph. : {items?.seller_mobile} <br />
                                      POS No. : {items?.seller_pos_number}
                                    </td>
                                    <td>{items?.code}</td>
                                    <td>{items?.points}</td>
                                    <td>{items?.qty}</td>
                                    <td>{items?.total_point}</td>
                                    <td>
                                      {moment(items?.expiry_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td dangerouslySetInnerHTML={{__html: statusMessage(items?.status)}}></td>
                                    <td>
                                      {moment(
                                        formatProjectDate(items?.createdAt)
                                      ).format("DD-MM-YYYY HH:mm")}
                                    </td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            {items.status === "Active" &&
                                              (PERMISSION?.fullAccess === "Y" ||
                                                PERMISSION?.cancel === "Y") && (
                                                <Menu.Item
                                                  key={`1`}
                                                  onClick={() => {
                                                    setCancelID(items._id);
                                                    // handleCancelOrder(items._id)
                                                    toggleConfirmPopup();
                                                  }}
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faTimes}
                                                  />{" "}
                                                  <span className="show_span">
                                                    Cancel
                                                  </span>
                                                </Menu.Item>
                                              )}
                                            {(PERMISSION?.fullAccess === "Y" ||
                                              PERMISSION?.view === "Y") && (
                                              <Menu.Item
                                                key={`2`}
                                                onClick={() => {
                                                  navigate(
                                                    "/promocodes/orderDetails",
                                                    { state: { items } }
                                                  );
                                                }}
                                              >
                                                <FontAwesomeIcon icon={faEye} />{" "}
                                                <span className="show_span">
                                                  View
                                                </span>
                                              </Menu.Item>
                                            )}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? (
                              <SkeltonList row={5} col={13} />
                            ) : (
                              <tr>
                                <td colspan="13" className="img-center">
                                  No data found!
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      <DownloadOrderStubsPopup
        popUpOpen={isStubDownloadShow}
        togglePopUp={handleStubDownloadDrawer}
      />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleFilterReset}
              style={{ backgroundColor: "red", color: "white" }}
            >
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id="filter_form" onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Field :
                </label>
                <select
                  name="filter_by"
                  className="form-control store_input_field"
                  id="filter_by"
                  onChange={handleFilterChange}
                  ref={inputRef1}
                >
                  <option value="">Select search field</option>
                  <option
                    value="order_no"
                    selected={filter?.filter_by === "order_no" ? true : false}
                  >
                    Order No
                  </option>
                  <option
                    value="buyer_first_name"
                    selected={
                      filter?.filter_by === "buyer_first_name" ? true : false
                    }
                  >
                    Buyer First Name
                  </option>
                  <option
                    value="buyer_last_name"
                    selected={
                      filter?.filter_by === "buyer_last_name" ? true : false
                    }
                  >
                    Buyer Last Name
                  </option>
                  <option
                    value="buyer_mobile"
                    selected={
                      filter?.filter_by === "buyer_mobile" ? true : false
                    }
                  >
                    Buyer Mobile No.
                  </option>
                  <option
                    value="buyer_area"
                    selected={filter?.filter_by === "buyer_area" ? true : false}
                  >
                    Buyer Area
                  </option>
                  <option
                    value="seller_first_name"
                    selected={
                      filter?.filter_by === "seller_first_name" ? true : false
                    }
                  >
                    Seller First Name
                  </option>
                  <option
                    value="seller_last_name"
                    selected={
                      filter?.filter_by === "seller_last_name" ? true : false
                    }
                  >
                    Seller Last Name
                  </option>
                  <option
                    value="seller_mobile"
                    selected={
                      filter?.filter_by === "seller_mobile" ? true : false
                    }
                  >
                    Seller Mobile No.
                  </option>
                  <option
                    value="seller_pos_number"
                    selected={
                      filter?.filter_by === "seller_pos_number" ? true : false
                    }
                  >
                    Seller POS No.
                  </option>
                  <option
                    value="code"
                    selected={filter?.filter_by === "code" ? true : false}
                  >
                    Promo Code
                  </option>
                  <option
                    value="points"
                    selected={filter?.filter_by === "points" ? true : false}
                  >
                    Points
                  </option>
                  <option
                    value="qty"
                    selected={filter?.filter_by === "qty" ? true : false}
                  >
                    Quantity
                  </option>
                  <option
                    value="total_point"
                    selected={
                      filter?.filter_by === "total_point" ? true : false
                    }
                  >
                    Total Points
                  </option>
                  <option
                    value="status"
                    selected={filter?.filter_by === "status" ? true : false}
                  >
                    Status
                  </option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="search"
                  className="all_section_for_label_main_class"
                >
                  Search Text :
                </label>
                {filter?.filter_by === "status" ? (
                  <select
                    name="search"
                    value={filter?.search}
                    onChange={handleFilterChange}
                    className="form-control store_input_field"
                    id="search"
                    ref={inputRef2}
                  >
                    <option value="">Select status</option>
                    <option value="Active">Active</option>
                    <option value="Cancel">Cancelled</option>
                  </select>
                ) : (
                  <input
                    title="Enter search text."
                    placeholder="Enter search text."
                    type="text"
                    name="search"
                    value={filter?.search}
                    onChange={handleFilterChange}
                    className="form-control store_input_field"
                    id="search"
                    ref={inputRef2}
                  />
                )}
              </div>
              
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"
                  ref={inputRef4}
                />
              </div>
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <ConfirmPopup
        popUpOpen={confirmPopup}
        togglePopUp={toggleConfirmPopup}
        process={handleCancelOrder}
      />
      <Loading isLoading={isLoading} />
    </>
  );
}
